import { createLoadActions } from '@copilot/common/store/actionCreators/list';
import { CampaignMemberModel } from '@copilot/common/utils/campaignMember/models';
import { CAMPAIGN_MEMBERS } from '@copilot/common/utils/campaignMember/constant';

export const campaignMemberLoadActions = createLoadActions<CampaignMemberModel>(CAMPAIGN_MEMBERS);
